export const tableMinWidth = (key: string): string => {

  switch (key) {
    case 'ussd_code':
    case 'user_code':
    case 'requester_user_code':
      return 'min-w-[120px]';
    case 'actions':
      return 'w-[120px]'
    case 'created_date':
    case 'last_logged_in':
    case 'transaction_date':
      return 'min-w-[200px]'
    case 'phone_number':
      return 'min-w-[150px]'
    case 'email_address':
      return 'min-w-[280px]'
    case 'split':
      return 'min-w-[200px]'
    case 'transaction_id':
      return 'min-w-[160px]'
    case 'transaction_category':
      return 'min-w-[140px]'
    case 'amount':
      return 'min-w-[150px]'
    case 'status':
      return 'min-w-[130px]';
    case 'transaction_status':
      return 'min-w-[160px]';
    case 'user_location':
      return 'min-w-[280px]';
    case 'user_name':
      return 'min-w-[50px]'
    case 'company_code':
      return 'min-w-[110px]'
    case "action_taken":
      return 'min-w-[110px]'
    case 'name':
      return 'min-w-[220px]'
    case 'contract_start_date':
    case 'contract_end_date':
      return 'min-w-[203px]'
    case 'etopup_balance':
    case 'wallet_balance':
    case 'balance':
      return 'min-w-[200px]'
    case 'service_fee_parent_display':
      return 'min-w-[250px]'
    case 'action_taken_at':
      return 'min-w-[250px]'
    case 'on_target_service_fee_percentage':
      return 'min-w-[450px]'
    case 'achievement_amount_received':
      return 'min-w-[400px]'
    case 'service_fee_received_date':
      return 'min-w-[200px]'
    case 'service_fee_processed_date':
      return 'min-w-[250px]'
    case 'service_fee_received_amount':
      return 'min-w-[180px]'
    case 'reference':
      return 'min-w-[320px]'
    case 'transaction_receipt':
      return 'min-w-[170px]'
    case "date":
      return 'min-w-fit'
    case 'description':
      return 'min-w-[400px]'
    case 'transaction_type':
      return 'min-w-[150px]'
    case 'channel_segment':
      return 'min-w-[150px]'
    case 'recharge_amount':
      return 'min-w-[180px]'
    case 'service_fee_type':
      return 'min-w-[150px]'
      
    default:
      return 'min-w-[200px]'; // You can return a default value if needed
  }
};

export interface TableDetailsItem {
  sort?: boolean;
  id?: string;
  sortKey?: string; // Optional property for custom sort key when different from id
  customHeader?: string;
  toggle?: boolean;
  custom?: string[];
  className?: string; // Optional property for custom classes
  actionTypes?: string[]; // Optional property for actions
  actionTypeAction?: { [key: string]: () => void }; // Optional property for action functions
  fixed?: boolean; // Optional property to make column sticky
}
